// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__2Qh+R","Text":"Logo_Text__UddI0","Name":"Logo_Name__0zFHM","Version":"Logo_Version__6YZJl"};